import { OccupancyType } from "layouts/roomavailabilitytracker/buildings/occupancyFilters/data";
import axios from '../../Uri'
export const getTotalAmountPaidByGuest = (guestId) => {
   return axios.get(`payment/getTotalPaid/${guestId}`);
}
export const getCountOfFiltersInRat=(buildingId)=>{
   return axios.get(`guest/getFilterBedsData/${buildingId}`);
}
export const getArchivedGuests=(pageNumber)=>{
   return axios.get(`/guest/findGuestAreVacated/VACATED?pageNumber=${pageNumber}&pageSize=25&sortBy=id&sortDir=desc`);
}
export const getLoginData=(pageNumber) => {
   return axios.get(`/info?pageNumber=${pageNumber}&pageSize=15&sortBy=id&sortDir=desc`)
}
export const cancelCheckout=(guestId)=>{
   return axios.get(`/guest/changeToRegular/${guestId}`);
}
export const allTransaction=(pageNumber) => {
   return   axios.get(`/payment/posts?pageNumber=${pageNumber}&pageSize=25&sortBy=id&sortDir=desc`);
}